import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/museum-app/utils/cn';
import { FileText } from 'lucide-react'; // Import icons
import { Button } from '@/components/ui/button'; // Import Button
import { useTranslation } from 'react-i18next'; // Import useTranslation

interface ExhibitDocumentsSkeletonProps {
  className?: string;
  count?: number; // Number of placeholder items
  onClick?: () => void; // Add onClick prop
}

export const ExhibitDocumentsSkeleton: React.FC<ExhibitDocumentsSkeletonProps> = ({
  className,
  count = 3,
  onClick,
}) => {
  const { t } = useTranslation();
  return (
      <div className={cn('relative grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3', className)}> {/* Add relative */}
          {Array.from({ length: count }).map((_, index) => (
              <div
                  key={index}
                  className="bg-card text-card-foreground flex w-full flex-wrap items-center space-x-3 rounded-lg border p-4 shadow-sm" // Adjusted padding
              >
                  {/* Icon placeholder */}
                  <Skeleton className="h-8 w-8 rounded" /> {/* Added icon skeleton */}
                  <div className="flex-1 space-y-2">
                      {/* Title placeholder */}
                      <Skeleton className="h-4 w-4/5" />
                      {/* Subtitle placeholder */}
                      <Skeleton className="h-3 w-2/5" />
                      <Skeleton className="h-3 w-2/8" />
                  </div>
                  {/* Button placeholder removed from item */}
              </div>
          ))}
          {/* Overlay Button */}
          {onClick && (
            <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-black/10 dark:bg-black/30">
                <Button variant="secondary" size="sm" onClick={onClick}>
                    <FileText className="mr-2 h-4 w-4" />
                    {t('common.viewDocuments', 'View Documents')} {/* Add translation key */}
                </Button>
            </div>
          )}
      </div>
  );
};
